import React from "react";
import { Table } from "antd";
import emptyStateImage from "../../assets/images/Illustration Small Empty.svg";
import { formatTranslation } from "../../shared/utils/translationUtils";
import { useTranslation } from "react-i18next";

interface ProtocolTableProps {
  protocols: any[];
  columns: any[];
  pagination: any;
  filters: any;
  isLoading: boolean;
  handlePagination: (pagination: any) => Promise<void>;
  handleRowClick: (protocolId: string) => void;
}

const ProtocolTable: React.FC<ProtocolTableProps> = ({
  protocols,
  columns,
  pagination,
  filters,
  handlePagination,
  handleRowClick,
  isLoading,
}) => {
  const { t } = useTranslation();

  const locale = {
    emptyText:
      !isLoading && protocols?.length === 0 ? (
        <div className="new-empty-state-content">
          <img src={emptyStateImage} alt="No Data" />
          <p className="new-empty-state-title">
            {filters.tab === "templates"
              ? formatTranslation(t("templates.newEmptyState.title"))
              : formatTranslation(t("protocols.newEmptyState.title"))}
          </p>
          <p className="new-empty-state-p">
            {formatTranslation(t("protocols.newEmptyState.content"))}
          </p>
        </div>
      ) : (
        <div></div>
      ),
  };

  return (
    <Table
      className={
        filters.tab === "archived" ? "archive-table" : "protocol-table"
      }
      dataSource={protocols}
      columns={columns}
      pagination={{
        ...pagination,
        position: [pagination?.total > 10 ? "bottomCenter" : "none"],
      }}
      onChange={(pagination: any): void => {
        void handlePagination(pagination);
      }}
      onRow={(record) => ({
        onClick: () => {
          filters.tab !== "templates" && handleRowClick(record.id);
        },
      })}
      locale={locale}
    />
  );
};

export default ProtocolTable;
